import type {User} from "../../../../data/models/User";
import type {UIVersion} from "../../../../data/state/AppState";
import {Permission} from "../../../../generated/api/base";
import {XyiconFeature} from "../../../../generated/api/reports";
import {SpaceExportWindowV5} from "../../../5.0/popup/SpaceExportWindowV5";
import {SpaceExportWindow} from "../../abstract/popups/SpaceExportWindow";

export const getUserCatalogPermission = (user?: User): Permission => {
	return user?.getOrganizationPermission(XyiconFeature.XyiconCatalog) ?? Permission.None;
};

export const doesUserHavePermissionToCreateCatalogItem = (user: User): boolean => {
	return user?.isAdmin || getUserCatalogPermission(user) >= Permission.Update;
};

export const openKeywordsPopupForFile = async (
	file: File,
	label: string,
	callback: (file: File, keywords: string[]) => Promise<void>,
	currentUiVersion: UIVersion,
) => {
	const name = file.name;
	const fileName = name.includes(".") ? name.substring(0, file.name.lastIndexOf(".")) : name;
	const popup = currentUiVersion === "5.0" ? SpaceExportWindowV5 : SpaceExportWindow;
	const keywordInput = await popup.open(
		`Enter one or more keywords separated by a comma to describe your custom ${label}.<br>Use the keywords to search for your ${label} when creating new catalog items.`,
		`Add keywords to custom ${label}`,
		[""],
		[fileName],
		1,
		{
			backdrop: false,
			cancel: "Cancel",
			ok: "Add Keywords",
		},
	);

	if (keywordInput != null) {
		const keywords = keywordInput[0].split(",").map((keyword) => keyword.replace(/\s{2,}/g, "").trim());

		await callback(file, keywords);
	}
};
